import React from 'react';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import { Box, Button, Card, CardContent, Grid, Tooltip, tooltipClasses, Typography } from '@mui/material';

const CONTACT_SALES_LIST = [
    {
        id: Math.random(),
        heading: 'I want an additional entity',
        para: 'If you need another entity, our business advisors can walk through strategies that will set you up for privacy and scale.',
        icon: '1.png',
        link: 'https://primecorporateservices.com/business-formation?utm_source=MKTG&utm_campaign=portal&utm_content=MKTG&utm_term=portal#pcs-schedule-consultation',
    },
    {
        id: Math.random(),
        heading: 'I want business credit',
        para: 'Build and strengthen your business credit profile to access better financing options and growth opportunities.',
        icon: '5.png',
        link: ' https://primecorporateservices.com/business-credit?utm_source=MKTG&utm_campaign=portal&utm_content=MKTG&utm_term=portal#pcs-schedule-consultation',
    },
    {
        id: Math.random(),
        heading: 'I want an estate plan',
        para: 'Protect your business and personal assets with a customized estate plan designed for entrepreneurs.',
        icon: '9.png',
        link: 'https://primecorporateservices.com/estate-planning?utm_source=MKTG&utm_campaign=portal&utm_content=MKTG&utm_term=portal#pcs-schedule-consultation',
    },
    {
        id: Math.random(),
        heading: 'I want help with taxes',
        para: 'Get expert tax prep tailored for business owners to maximize deductions and stay compliant.',
        icon: '2.jpg',
        link: 'https://primecorporateservices.com/tax-preparation?utm_source=MKTG&utm_campaign=portal&utm_content=MKTG&utm_term=portal#pcs-schedule-consultation',
    },
    {
        id: Math.random(),
        heading: 'I want to add other services',
        para: `Whether you're looking to add a registered agent, bankable website, or other services, schedule a call to discuss the best way to round out your services!`,
        icon: '8.png',
        link: 'https://www.primecorporateservices.com/#schedule',
    },
];
function ContactSales() {
    //        if (true) {
    //        return skeleton;
    //    }
    return (
        <MainContainer>
            <MainHeading gutterBottom>Contact Sales</MainHeading>
            <ParaText>
                Whether you're expanding with a new entity, building business credit, preparing for tax season, or securing your legacy with an estate plan, our advisors are here to help. Choose the
                option that fits your needs, and let’s take the next step together.
            </ParaText>

            <Grid container spacing={2} marginTop={'1rem'}>
                {CONTACT_SALES_LIST.map((cItem, index) => {
                    return (
                        <Grid
                            key={cItem.id}
                            item
                            xs={12}
                            md={6}
                            lg={4}
                            sx={{
                                '@media (min-width:1200px) and (max-width:1400px)': {
                                    maxWidth: '50%',
                                    flexBasis: '50%',
                                },
                            }}
                        >
                            <Card
                                sx={
                                    {
                                        // minHeight: '158px',
                                        // maxHeight: '158px',
                                    }
                                }
                            >
                                <CardContent
                                    sx={(theme) => ({
                                        display: 'flex',
                                        '&:last-child': {
                                            padding: '1rem',
                                        },
                                        [theme.breakpoints.down('sm')]: {
                                            flexDirection: 'column',
                                            overflow: 'auto',
                                        },
                                    })}
                                >
                                    <Box display={'flex'} justifyContent={{ xs: 'start', sm: 'center' }} alignItems={'center'}>
                                        <Box
                                            component={'img'}
                                            variant="outlined"
                                            borderRadius={'50%'}
                                            border={(theme) => `1px solid ${theme.palette.border.neutralPrimary}`}
                                            minHeight={{ xs: '5rem', sm: '6rem' }}
                                            minWidth={{ xs: '5rem', sm: '6rem' }}
                                            height={{ xs: '5rem', sm: '6rem' }}
                                            width={{ xs: '5rem', sm: '6rem' }}
                                            padding={'0.5rem'}
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            marginTop={{ xs: '0', sm: '-1.5rem' }}
                                            src={`/images/imgs/${cItem.icon}`}
                                            alt=""
                                        ></Box>
                                    </Box>
                                    <Box
                                        marginLeft={{ xs: '0rem', sm: '1rem' }}
                                        marginTop={{
                                            xs: '1rem',
                                            sm: '0rem',
                                        }}
                                        flex={1}
                                    >
                                        <Typography
                                            component={'h2'}
                                            variant="paraText1"
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1, // Limit to 1 lines
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {cItem.heading}
                                        </Typography>

                                        <Tooltip
                                            title={cItem.para}
                                            arrow
                                            placement="bottom"
                                            slotProps={{
                                                popper: {
                                                    sx: {
                                                        [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                                                            marginTop: '-40px',
                                                        },
                                                    },
                                                },
                                            }}
                                        >
                                            <Typography
                                                component={'p'}
                                                variant="paraText3"
                                                sx={{
                                                    '@media (min-width:601px)': {
                                                        justifyContent: 'start',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 5, // Limit to 5 lines
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',

                                                        minHeight: '115px',
                                                        maxHeight: '115px',
                                                    },
                                                }}
                                            >
                                                {cItem.para}
                                            </Typography>
                                        </Tooltip>

                                        <Box display={'flex'} justifyContent={{ xs: 'flex-start', sm: 'flex-end' }} marginTop={{ xs: '1rem', sm: '0.5rem' }}>
                                            <Button href={cItem.link} target="_blank" variant="contained" color="primary">
                                                Schedule Consultation
                                            </Button>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            <Box sx={{ paddingTop: '2rem' }} />
        </MainContainer>
    );
}

export default ContactSales;
